
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 2.5L1.667 4.167v11.666L10 17.5v-15zm1.667 1.667v1.666h1.667V7.5h-1.667v1.667h1.667v1.666h-1.667V12.5h1.667v1.667h-1.667v1.666H17.5c.46 0 .834-.373.834-.833V5a.834.834 0 00-.834-.833h-5.833zM15 5.833h1.667V7.5H15V5.833zM3.48 6.914h1.481l.77 1.846c.063.15.11.326.158.524h.021c.028-.12.084-.301.168-.539l.858-1.83h1.35L6.674 9.971l1.66 3.114h-1.44l-.929-2.012a1.71 1.71 0 01-.11-.412h-.013c-.021.095-.063.238-.126.428l-.935 1.996H3.334l1.717-3.09-1.57-3.082zM15 9.167h1.667v1.666H15V9.167zm0 3.333h1.667v1.667H15V12.5z"}})])
          )
        }
      }
    